package gr.tech.pdfgenerator.util

import kotlinx.serialization.json.Json

val JsonWithDefault = Json {
    encodeDefaults = true
}
